import React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

const SimpleTooltip = ({
  children,
  asChild,
  content,
}: {
  children: React.ReactNode;
  asChild?: boolean;
  content: string;
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      <TooltipContent>
        <p>{content}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default SimpleTooltip;
